import { Badge, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@shared/ui/primitives';

interface McpAdminPageShellProps {
  title: string;
  description: string;
  phaseBadge?: boolean;
  children: React.ReactNode;
}

export function McpAdminPageShell({ title, description, phaseBadge = true, children }: McpAdminPageShellProps) {
  return (
    <div className="space-y-6 p-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        </div>
        {phaseBadge && (
          <Badge variant="secondary">Phase 1 · MCP MVP</Badge>
        )}
      </div>
      {children}
    </div>
  );
}

export function McpStatCard({
  label,
  value,
  status,
}: {
  label: string;
  value: string | number;
  status?: 'ok' | 'warn' | 'error' | 'neutral';
}) {
  const variant =
    status === 'ok' ? 'default' : status === 'warn' ? 'secondary' : status === 'error' ? 'destructive' : 'outline';
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardDescription>{label}</CardDescription>
        <CardTitle className="text-lg flex items-center gap-2">
          {value}
          {status && status !== 'neutral' && <Badge variant={variant}>{status}</Badge>}
        </CardTitle>
      </CardHeader>
    </Card>
  );
}

export function CopyField({ label, value }: { label: string; value: string }) {
  const copy = () => navigator.clipboard.writeText(value);
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardDescription>{label}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-2">
        <code className="flex-1 rounded bg-muted px-2 py-1 text-xs break-all">{value}</code>
        <button type="button" className="text-sm text-primary underline" onClick={copy}>
          복사
        </button>
      </CardContent>
    </Card>
  );
}
